import type { InternalAxiosRequestConfig } from 'axios';
import type { AuthProvider, AuthType } from './AuthProvider';

export class ApiKeyAuthProvider implements AuthProvider {
  readonly authType: AuthType = 'api-key';

  private readonly apiKey: string;
  private readonly apiSecret: string;

  constructor({ apiKey, apiSecret }: { apiKey: string; apiSecret: string }) {
    if (!apiKey || !apiSecret) {
      throw new Error(
        'ApiKeyAuthProvider requires both an api key and secret. Set `apiKey` and `apiSecret` on the /config page.'
      );
    }
    this.apiKey = apiKey;
    this.apiSecret = apiSecret;
  }

  applyTo(request: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
    request.headers.set('X-Api-Key', this.apiKey);
    request.headers.set('X-Api-Secret', this.apiSecret);
    return request;
  }
}
